import { useState } from 'react';
import { Chip } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';
import AdminUserAssignmentDialog from './components/AdminUserAssignmentDialog';

const AdminOrganizationsPage = () => {
  const [assignmentTarget, setAssignmentTarget] = useState(null);
  const [refreshToken, setRefreshToken] = useState(0);

  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'slug', label: 'Slug' },
    { key: 'plan', label: 'Plan' },
    { key: 'member_count', label: 'Members' },
    {
      key: 'is_active',
      label: 'Status',
      render: (row) =>
        row.is_active ? (
          <Chip size="small" label="Active" sx={{ bgcolor: 'rgba(22,163,74,0.12)', color: '#166534', fontWeight: 600 }} />
        ) : (
          <Chip size="small" label="Inactive" sx={{ bgcolor: 'rgba(220,38,38,0.12)', color: '#991b1b', fontWeight: 600 }} />
        )
    }
  ];

  const fields = [
    { name: 'name', label: 'Name', type: 'text', grid: 6 },
    { name: 'slug', label: 'Slug', type: 'text', grid: 6 },
    { name: 'plan', label: 'Plan', type: 'select', grid: 6, defaultValue: 'community', options: [
      { value: 'community', label: 'Community' },
      { value: 'pro', label: 'Pro' },
      { value: 'enterprise', label: 'Enterprise' }
    ] },
    { name: 'is_active', label: 'Active', type: 'switch', grid: 6, defaultValue: true },
    { name: 'description', label: 'Description', type: 'multiline', grid: 12 }
  ];

  return (
    <>
      <AdminResourceCrudPage
        title="Organizations"
        subtitle="Manage tenants, plans, and organization-level ownership."
        icon={ApartmentIcon}
        endpoint="/api/admin/organizations/"
        columns={columns}
        fields={fields}
        loadParams={{ refresh: refreshToken }}
        rowActions={[
          {
            label: 'Set Members',
            icon: GroupAddIcon,
            onClick: async (row) => {
              setAssignmentTarget(row);
            }
          }
        ]}
      />
      <AdminUserAssignmentDialog
        open={Boolean(assignmentTarget)}
        endpoint={assignmentTarget ? `/api/admin/organizations/${assignmentTarget.id}/members/` : ''}
        title={assignmentTarget ? `Organization Members - ${assignmentTarget.name}` : 'Organization Members'}
        subtitle="Select users to include in this organization."
        roleOptions={[
          { value: 'owner', label: 'Owner' },
          { value: 'admin', label: 'Admin' },
          { value: 'member', label: 'Member' }
        ]}
        defaultRole="member"
        onSaved={async () => setRefreshToken((prev) => prev + 1)}
        onClose={() => setAssignmentTarget(null)}
      />
    </>
  );
};

export default AdminOrganizationsPage;
